import React, { createContext, useContext, useEffect, useMemo, useState, ReactNode } from 'react';
import AdminAPI from '../api/admin.ts';

interface AdminContextType {
  api: AdminAPI;
  authenticated: boolean;
  username: string;
  setAuthenticated: (v: boolean) => void;
  logout: () => void;
}

const AdminContext = createContext<AdminContextType | undefined>(undefined);

export const AdminProvider = ({ children }: { children: ReactNode }) => {
  const api = useMemo(() => new AdminAPI(), []);
  const [authenticated, setAuthenticated] = useState<boolean>(api.isAuthenticated());
  const [username, setUsername] = useState<string>('');

  useEffect(() => {
    if (!authenticated) {
      setUsername('');
      return;
    }
    api.me().then(r => setUsername(r.username || '')).catch(() => {});
  }, [authenticated, api]);

  const logout = () => {
    api.clearToken();
    setAuthenticated(false);
    setUsername('');
  };

  return (
    <AdminContext.Provider value={{ api, authenticated, username, setAuthenticated, logout }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error('useAdmin must be used within AdminProvider');
  return ctx;
};
